import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { ForgotPasswordForm } from '@/features/auth/components/ForgotPasswordForm';

export const Route = createFileRoute('/client_/forgot-password/')({ component: Page });

function Page() {
  return (
    <AuthLayout formSide="right" brandPanel={<ClientAuthBrandPanel />}>
      <ForgotPasswordForm variant="client" />
    </AuthLayout>
  );
}
